"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const MemberAddressToolTip = () => (react_1.default.createElement(CustomToolTip_1.default, { type: '?', info: 'Enter the best mailing address for your Member. This could be a business address, PO Box, or your home address.' }));
exports.default = MemberAddressToolTip;
